
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getOrderGroup",
      resolverType: "query",
      routePath: "/getOrderGroup",
      httpMethod: "POST",
    });
  